module.exports = __webpack_public_path__ + "img/xggq2.307f0189.jpg";